import React, { useEffect, useState } from 'react'
import { useInView } from "react-intersection-observer";
import ProjectCard from './ProjectCard'
import { projects } from '../../config/ProjectsData'
import HorizontalLine from '../HorizontalLine'
import { motion, useAnimation } from "framer-motion";

const Projects = ({ projectRef }) => {
  const [ref, inView] = useInView();
  const boxAnimation = useAnimation({ thresold: 0.1 });

  useEffect(() => {
    if (inView) {
      boxAnimation.start({
        y:0,
        opacity:1,
        transition: {
          duration: 0.3,
          ease:"easeInOut"
        }

      })
      console.log("boxanimation")
    }
    else {
      
      boxAnimation.start({
        y: 50,
        opacity:0,
       
      })
    }
  },[inView])
  return (
    <div
      ref={projectRef}
      className='pt-40 px-2 lg:px-20 '>
      <div className='py-8'>
        <HorizontalLine section={"Projects"} />
      </div>
      <motion.div
        ref={ref}
        animate={boxAnimation}
        className='flex flex-col lg:flex-row flex-wrap justify-center px-2 lg:px-20 py-1 lg:py-5 lg:shadow-2xl lg:shadow-blue-300 rounded-md'>
        
        {projects.map((item, index) => <ProjectCard
          key={item.name}
          animationTime={index%2===0?-400:400}
          data={item} />
      )}
      
    </motion.div>
    </div>
    
   
  )
}

export default Projects
